import { fetchCart } from './api';
import { sortItems } from './utils';

export const getCart = () => {
  return fetchCart().then(sortItems);
};
